var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "pt-3" }, [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("message.my_listings.add_pet_types")))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text-info",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.showModal = true
              }
            }
          },
          [_c("i", { staticClass: "fal fa-exclamation-square fa-lg" })]
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
            _vm._v(
              _vm._s(_vm.$t("message.my_listings.pet_recommendation_title"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c("img", {
              attrs: { src: "/static//img/puppy-svgrepo-com.svg", withd: "128" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bg-light rounded p-2 mt-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.my_listings.pet_recommendation01")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bg-light rounded p-2 mt-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.my_listings.pet_recommendation02")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer"
            },
            [
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.showModal = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.button.close")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67dda8f4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67dda8f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/PetSelectionLabel.vue
// module id = 1835
// module chunks = 0